import { Tag01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { NoRowsFallback } from "shared/components/DataGridTable/slices/NoRowsFallback";

/** Empty Leads table: with a Tags filter on, offer to clear it. */
export const LeadsNoRowsFallback = ({
  hasTagFilter,
  onClearTagFilter
}: {
  hasTagFilter: boolean;
  onClearTagFilter: () => void;
}) =>
  hasTagFilter ? (
    <NoRowsFallback
      Icon={Tag01Icon}
      title="No leads match the selected tags"
      text={null}
      buttonText="Clear tag filter"
      buttonAction={onClearTagFilter}
    />
  ) : (
    <NoRowsFallback />
  );
